import React from "react";
import { withStory, WithStoryProps } from "@storyofams/storyblok-toolkit";
import { createClient } from "@supabase/supabase-js";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { useRouter } from "next/router";
import { Recipe } from "~components/recipe/Recipe";
import { Container, Seo } from "../../components";
import { enhancedStaticProps, withLayout } from "../../lib";

import { loadRecipeProducts } from "../../lib/loadRecipeProducts";
import { ProductByHandleQuery } from "../../lib/shopify/sdk";

interface RecipePageProps extends WithStoryProps {
  featured_products: ProductByHandleQuery["productByHandle"][];
  recipe: any;
}
const Home: NextPage<RecipePageProps> = ({ recipe }) => {
  const {
    query: { slug },
  } = useRouter();
  console.log(recipe);
  return (
    <>
      <Seo
        title={`${recipe?.title?.text} (Recept)`}
        description={recipe?.description?.text}
        image={recipe.image}
        canonical={`https://www.naturalheroes.nl/recipes/${slug}`}
      />
      <Container maxWidth={"1334px"} px={2} alignItems="center">
        <Recipe recipe={recipe} />
      </Container>
    </>
  );
};

export default withLayout(withStory(Home));

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    fallback: "blocking",
    paths: [],
  };
};

export const getStaticProps: GetStaticProps<WithStoryProps> =
  enhancedStaticProps(async ({ sdk, params, locale, defaultLocale }) => {
    const supabase = createClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL,
      process.env.NEXT_PUBLIC_SUPABASE_KEY
    );
    let story = null;
    let notFound = false;
    let recipe = null;
    try {
      //@ts-ignore library issue
      let { data } = await supabase
        .from("recipes")
        .select(
          "*, category(text, id),recipe_category(id, category_name), contents_uom(text), description(text), how_to_use(text), difficulty(text), makes_uom(text), summary(text), title(text), recipes_steps(id, text_content(text), video, photo, name, step_order), recipes_ingredients(*, recipes_alternative_ingredients(*)), recipes_tools(*), tags(*), recipes_usage(id, text_content(text), video, photo), recipes_faq(question_text(text), answer_text(text)), recipes_reviews(email, rating), media_links)"
        )
        .in("slug", [params.slug[0], params.slug[0].toLocaleLowerCase()]);
      recipe = data[0];
    } catch (err) {
      notFound = true;
    }
    if (!recipe?.published && params.slug[1] !== "TmF0dXJhbCBIZXJvZXM=")
      notFound = true;
    else {
      await loadRecipeProducts(story, locale, recipe);
    }
    return {
      props: {
        story,
        recipe,
        params,
      },
      notFound,
      revalidate: process.env.HOST === "dev.naturalheroes.nl" ? 1 : 600,
    };
  });
